<template>
  <v-card>
    <v-toolbar flat dense dark color="primary">
      <v-toolbar-title>Twój trener</v-toolbar-title>
    </v-toolbar>
    <v-layout row wrap>
      <v-flex xs12 sm6 md4 lg3 class="text-xs-center mt-5">
        <img width="200" v-if="runnersTrainer.avatar_thumbnail" class="d-inline-block avatar" :src="runnersTrainer.avatar_thumbnail" />
        <img width="200" v-if="!runnersTrainer.avatar_thumbnail" class="d-inline-block avatar" src="@/assets/img/avatar.png" />
      </v-flex>
      <v-flex xs12 sm6 md5 lg4>
        <v-list class="personal-fields" two-line>
            <v-list-tile  @click="">
              <v-list-tile-content>
                <v-list-tile-sub-title >Imię i nazwisko</v-list-tile-sub-title>
                <v-list-tile-title>{{runnersTrainer.full_name}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile  @click="">
              <v-list-tile-content>
                <v-list-tile-sub-title >Telefon</v-list-tile-sub-title>
                <v-list-tile-title>
                  <a :href="'tel:' + runnersTrainer.phone">{{runnersTrainer.phone}}</a>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile  @click="">
              <v-list-tile-content>
                <v-list-tile-sub-title >Email</v-list-tile-sub-title>
                <v-list-tile-title><a :href="'mailto:' + runnersTrainer.email">{{runnersTrainer.email}}</a></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile  @click="">
              <v-list-tile-content>
                <v-list-tile-sub-title >O sobie</v-list-tile-sub-title>
                <v-list-tile-title>{{runnersTrainer.about}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </v-card>
</template>


<script>
import { mapState } from 'vuex'
import * as types from '@/store/mutation-types'
import store from '@/store'

export default {
  computed: {
    ...mapState(['runnersTrainer'])
  },
  created () {
    this.$store.dispatch(types.RUNNERS_TRAINER_REQUEST, store.state.runner)
  }
}
</script>
<style>
.personal-fields .v-list__tile--link.v-list__tile {
  min-height: 72px;
  height: auto;
}
.personal-fields .v-list__tile__content {
  min-height: 72px;
  height: auto;
}
.personal-fields .v-list__tile__title {
  height: auto;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/trainers/TrainerDataPresentation.vue